/** API response/request shapes matching FastAPI schemas (#675/#676). */

export type MeResponse = {
  id: string
  email: string
  email_verified: boolean
  mfa_enrolled: boolean
  csrf_token: string
}

export type RegisterResponse = {
  id: string
  email: string
}

export type MfaSetupResponse = {
  otpauth_uri: string
}

export type MfaConfirmResponse = {
  recovery_codes: string[]
}

export type MfaRecoverStartResponse = {
  recovery_token: string
  otpauth_uri: string
}

export type DropObjectView = {
  object_id: string
  relative_path: string
  size_bytes: number
  content_type: string
  sha256: string
  uploaded_verified_at: string | null
}

export type DropView = {
  drop_id: string
  status: string
  phone_last4: string
  ttl_hours: number
  created_at: string
  finalized_at: string | null
  expires_at: string | null
  revoked_at: string | null
  expired_at: string | null
  object_count: number
  total_bytes: number
  objects?: DropObjectView[] | null
}

export type DropListResponse = {
  drops: DropView[]
}

export type PrepareObjectSpec = {
  relative_path: string
  size_bytes: number
  content_type: string
  sha256: string
}

export type PreparedObjectResponse = {
  object_id: string
  relative_path: string
  blob_name: string
  write_sas_url: string
  expires_at: string
}

export type PrepareObjectsResponse = {
  objects: PreparedObjectResponse[]
}

export type FinalizeDropResponse = {
  drop_id: string
  share_url: string
  expires_at: string
}

export type OtpSendResponse = {
  drop_id: string
  phone_last4: string
  expires_at: string
}

export type OtpVerifyResponse = {
  drop_id: string
  expires_at: string
  csrf_token: string
}

export type RecipientSessionResponse = {
  drop_id: string
  expires_at: string
  csrf_token: string
}

export type RecipientObjectView = {
  object_id: string
  relative_path: string
  size_bytes: number
  content_type: string
}

export type RecipientObjectListResponse = {
  drop_id: string
  objects: RecipientObjectView[]
  total_bytes: number
}

export type DownloadSasResponse = {
  url: string
  expires_at: string
  blob_name: string
}

export class ApiError extends Error {
  status: number
  detail: string
  retryAfterSeconds: number | null

  constructor(status: number, detail: string, retryAfterSeconds: number | null = null) {
    super(detail)
    this.name = 'ApiError'
    this.status = status
    this.detail = detail
    this.retryAfterSeconds = retryAfterSeconds
  }
}
